var _g, _path, _path2, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1819,
    height: 998,
    viewBox: "0 0 1819 998",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.28 921.078H147.91V936.454H161.28V921.078Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.393 767.289H148.023V782.665H161.393V767.289Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.241 951.852H147.871V967.227H161.241V951.852Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.448 705.766H148.078V721.141H161.448V705.766Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.413 736.531H148.043V751.907H161.413V736.531Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.225 982.602H147.855V997.977H161.225V982.602Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6983 845.391H66.7148V858.252H82.6983V845.391Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7296 845.359H34.7461V858.221H50.7296V845.359Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7452 845.344H2.76172V858.205H18.7452V845.344Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.558 845.523H258.574V858.385H274.558V845.523Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.523 845.555H290.539V858.416H306.523V845.555Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.589 845.5H226.605V858.361H242.589V845.5Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7455 939.723L42.4336 950.586L51.8792 959.688L63.1911 948.825L53.7455 939.723Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.777 765.813L223.469 776.68L232.918 785.779L244.226 774.912L234.777 765.813Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.396 744.081L246.086 754.945L255.533 764.046L266.843 753.181L257.396 744.081Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16 787.575L200.848 798.438L210.293 807.54L221.605 796.677L212.16 787.575Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3822 917.973L65.0703 928.836L74.5159 937.938L85.8278 927.075L76.3822 917.973Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0267 896.219L87.7188 907.086L97.1676 916.185L108.476 905.318L99.0267 896.219Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0675 743.937L42.6055 753.023L53.8976 763.905L63.3597 754.819L52.0675 743.937Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.808 918.092L223.348 927.18L234.642 938.059L244.102 928.972L232.808 918.092Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.232 896.328L200.77 905.414L212.062 916.296L221.524 907.209L210.232 896.328Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.407 939.851L245.945 948.938L257.237 959.819L266.7 950.733L255.407 939.851Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2534 787.49L87.793 796.578L99.0871 807.458L108.548 798.37L97.2534 787.49Z",
    fill: "#4BAD9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.673 765.718L65.2109 774.805L76.5031 785.686L85.9652 776.6L74.673 765.718Z",
    fill: "#4BAD9B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1127.06 573.831L1085.32 614.164L1088.49 617.22L1130.22 576.887L1127.06 573.831Z",
    fill: "#4CAD9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.2 573.831L1109.47 614.164L1112.63 617.22L1154.36 576.887L1151.2 573.831Z",
    fill: "#4CAD9B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1612.15 228.5H1605.61V236.027H1612.15V228.5Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.21 153.211H1605.66V160.738H1612.21V153.211Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.13 243.562H1605.59V251.09H1612.13V243.562Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.23 123.094H1605.69V130.621H1612.23V123.094Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.21 138.156H1605.67V145.683H1612.21V138.156Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.12 258.617H1605.58V266.144H1612.12V258.617Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573.68 191.445H1565.86V197.741H1573.68V191.445Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1558.03 191.43H1550.21V197.726H1558.03V191.43Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.37 191.422H1534.55V197.718H1542.37V191.422Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.6 191.508H1659.78V197.804H1667.6V191.508Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.25 191.531H1675.43V197.827H1683.25V191.531Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.95 191.5H1644.13V197.796H1651.95V191.5Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.51 237.628L1553.97 242.945L1558.59 247.401L1564.13 242.083L1559.51 237.628Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.13 152.493L1642.59 157.812L1647.22 162.267L1652.76 156.947L1648.13 152.493Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.2 141.853L1653.66 147.172L1658.29 151.627L1663.83 146.308L1659.2 141.853Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.06 163.143L1631.52 168.461L1636.14 172.917L1641.68 167.599L1637.06 163.143Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.59 226.979L1565.05 232.297L1569.67 236.753L1575.21 231.435L1570.59 226.979Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.67 216.329L1576.14 221.648L1580.76 226.103L1586.3 220.783L1581.67 216.329Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1558.68 141.778L1554.05 146.227L1559.58 151.554L1564.21 147.105L1558.68 141.778Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.17 227.035L1642.54 231.484L1648.06 236.811L1652.7 232.362L1647.17 227.035Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1636.11 216.388L1631.48 220.836L1637.01 226.163L1641.64 221.715L1636.11 216.388Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.23 237.692L1653.59 242.141L1659.12 247.468L1663.75 243.02L1658.23 237.692Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.8 163.098L1576.17 167.547L1581.7 172.873L1586.33 168.424L1580.8 163.098Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.75 152.442L1565.12 156.891L1570.65 162.218L1575.28 157.77L1569.75 152.442Z",
    fill: "#4BAD9B",
    fillOpacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.535 754.609H405.863V761.132H411.535V754.609Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.582 689.367H405.91V695.89H411.582V689.367Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.52 767.664H405.848V774.187H411.52V767.664Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.606 663.266H405.934V669.789H411.606V663.266Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.59 676.32H405.918V682.843H411.59V676.32Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.512 780.711H405.84V787.234H411.512V780.711Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.199 722.5H371.418V727.956H378.199V722.5Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.636 722.484H357.855V727.941H364.636V722.484Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.066 722.477H344.285V727.933H351.066V722.477Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.593 722.555H452.812V728.011H459.593V722.555Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.152 722.57H466.371V728.027H473.152V722.57Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.031 722.547H439.25V728.003H446.031V722.547Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.912 762.524L361.113 767.133L365.12 770.994L369.919 766.386L365.912 762.524Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.715 688.742L437.918 693.352L441.927 697.212L446.724 692.602L442.715 688.742Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.314 679.524L447.516 684.133L451.524 687.994L456.322 683.384L452.314 679.524Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.119 697.97L428.32 702.578L432.328 706.44L437.127 701.831L433.119 697.97Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.518 753.298L370.719 757.906L374.726 761.768L379.525 757.159L375.518 753.298Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.125 744.062L380.328 748.672L384.337 752.532L389.134 747.922L385.125 744.062Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.202 679.458L361.188 683.312L365.978 687.929L369.992 684.074L365.202 679.458Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.881 753.34L437.867 757.195L442.659 761.811L446.672 757.955L441.881 753.34Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.303 744.114L428.289 747.969L433.08 752.585L437.094 748.73L432.303 744.114Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.467 762.575L447.453 766.43L452.244 771.046L456.258 767.191L451.467 762.575Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.373 697.934L380.359 701.789L385.151 706.405L389.164 702.549L384.373 697.934Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.792 688.7L370.777 692.555L375.568 697.171L379.582 693.316L374.792 688.7Z",
    fill: "#4BAD9B",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.959 308.76L308.887 348.906L312.064 345.864L270.136 305.718L266.959 308.76Z",
    fill: "#4CAD9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.963 285.534L308.891 325.68L312.067 322.638L270.139 282.492L266.963 285.534Z",
    fill: "#4CAD9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00165336 397.307L41.9297 437.453L45.1065 434.411L3.17848 394.265L0.00165336 397.307Z",
    fill: "#4CAD9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00555961 374.08L41.9336 414.227L45.1104 411.185L3.18238 371.039L0.00555961 374.08Z",
    fill: "#4CAD9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1761.93 624.002L1803.86 664.148L1807.03 661.107L1765.1 620.961L1761.93 624.002Z",
    fill: "#4CAD9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1761.93 600.776L1803.86 640.922L1807.04 637.88L1765.11 597.734L1761.93 600.776Z",
    fill: "#4CAD9B"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip3_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.895 358.902L568.895 363.07L573.103 363.07L573.103 358.902L568.895 358.902Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.895 350.566L568.895 354.734L573.103 354.734L573.103 350.566L568.895 350.566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.895 342.23L568.895 346.398L573.103 346.398L573.103 342.23L568.895 342.23Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.363 358.902L578.363 363.07L582.572 363.07L582.572 358.902L578.363 358.902Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.363 350.566L578.363 354.734L582.572 354.734L582.572 350.566L578.363 350.566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.363 342.23L578.363 346.398L582.572 346.398L582.572 342.23L578.363 342.23Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.363 333.894L578.363 338.062L582.572 338.063L582.572 333.894L578.363 333.894Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.832 358.902L587.832 363.07L592.041 363.07L592.041 358.902L587.832 358.902Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.832 350.566L587.832 354.734L592.041 354.734L592.041 350.566L587.832 350.566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.832 342.23L587.832 346.398L592.041 346.398L592.041 342.23L587.832 342.23Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.832 333.894L587.832 338.062L592.041 338.063L592.041 333.894L587.832 333.894Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.832 325.558L587.832 329.727L592.041 329.727L592.041 325.558L587.832 325.558Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.301 350.566L597.301 354.734L601.51 354.734L601.51 350.566L597.301 350.566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.301 342.23L597.301 346.398L601.51 346.398L601.51 342.23L597.301 342.23Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.301 333.894L597.301 338.062L601.51 338.063L601.51 333.894L597.301 333.894Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.301 325.558L597.301 329.727L601.51 329.727L601.51 325.558L597.301 325.558Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.301 317.019L597.301 321.188L601.51 321.188L601.51 317.019L597.301 317.019Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.77 342.23L606.77 346.398L610.978 346.398L610.978 342.23L606.77 342.23Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.77 333.894L606.77 338.062L610.978 338.063L610.978 333.894L606.77 333.894Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.77 325.558L606.77 329.727L610.978 329.727L610.978 325.558L606.77 325.558Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.77 317.019L606.77 321.188L610.978 321.188L610.978 317.019L606.77 317.019Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.234 333.894L616.234 338.062L620.443 338.063L620.443 333.894L616.234 333.894Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.234 325.558L616.234 329.727L620.443 329.727L620.443 325.558L616.234 325.558Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.234 317.019L616.234 321.188L620.443 321.188L620.443 317.019L616.234 317.019Z",
    fill: "#FAFAFA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip4_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.57 382.176L491.57 387.867L497.282 387.867L497.282 382.176L491.57 382.176Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.57 370.793L491.57 376.484L497.282 376.484L497.282 370.793L491.57 370.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.57 359.418L491.57 365.109L497.282 365.109L497.282 359.418L491.57 359.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.422 382.176L504.422 387.867L510.134 387.867L510.134 382.176L504.422 382.176Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.422 370.793L504.422 376.484L510.134 376.484L510.134 370.793L504.422 370.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.422 359.418L504.422 365.109L510.134 365.109L510.134 359.418L504.422 359.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.422 348.035L504.422 353.727L510.134 353.727L510.134 348.035L504.422 348.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.27 382.176L517.27 387.867L522.982 387.867L522.982 382.176L517.27 382.176Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.27 370.793L517.27 376.484L522.982 376.484L522.982 370.793L517.27 370.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.27 359.418L517.27 365.109L522.982 365.109L522.982 359.418L517.27 359.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.27 348.035L517.27 353.727L522.982 353.727L522.982 348.035L517.27 348.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.27 336.652L517.27 342.344L522.982 342.344L522.982 336.652L517.27 336.652Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.121 370.793L530.121 376.484L535.833 376.484L535.833 370.793L530.121 370.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.121 359.418L530.121 365.109L535.833 365.109L535.833 359.418L530.121 359.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.121 348.035L530.121 353.727L535.833 353.727L535.833 348.035L530.121 348.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.121 336.652L530.121 342.344L535.833 342.344L535.833 336.652L530.121 336.652Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.121 324.996L530.121 330.688L535.833 330.688L535.833 324.996L530.121 324.996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.973 359.418L542.973 365.109L548.685 365.109L548.685 359.418L542.973 359.418Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.973 348.035L542.973 353.727L548.685 353.727L548.685 348.035L542.973 348.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.973 336.652L542.973 342.344L548.685 342.344L548.685 336.652L542.973 336.652Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.973 324.996L542.973 330.688L548.685 330.688L548.685 324.996L542.973 324.996Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.82 348.035L555.82 353.727L561.532 353.727L561.532 348.035L555.82 348.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.82 336.652L555.82 342.344L561.532 342.344L561.532 336.652L555.82 336.652Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.82 324.996L555.82 330.688L561.532 330.688L561.532 324.996L555.82 324.996Z",
    fill: "#FAFAFA"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip5_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.539 122.464L167.539 126.633L171.748 126.633L171.748 122.464L167.539 122.464Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.539 114.128L167.539 118.297L171.748 118.297L171.748 114.128L167.539 114.128Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.539 105.793L167.539 109.961L171.748 109.961L171.748 105.793L167.539 105.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.008 122.464L177.008 126.633L181.217 126.633L181.217 122.464L177.008 122.464Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.008 114.128L177.008 118.297L181.217 118.297L181.217 114.128L177.008 114.128Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.008 105.793L177.008 109.961L181.217 109.961L181.217 105.793L177.008 105.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.008 97.4566L177.008 101.625L181.217 101.625L181.217 97.4566L177.008 97.4566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.477 122.464L186.477 126.633L190.686 126.633L190.686 122.464L186.477 122.464Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.477 114.128L186.477 118.297L190.686 118.297L190.686 114.128L186.477 114.128Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.477 105.793L186.477 109.961L190.686 109.961L190.686 105.793L186.477 105.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.477 97.4566L186.477 101.625L190.686 101.625L190.686 97.4566L186.477 97.4566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.477 89.1206L186.477 93.2891L190.686 93.2891L190.686 89.1206L186.477 89.1206Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.945 114.128L195.945 118.297L200.154 118.297L200.154 114.128L195.945 114.128Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.945 105.793L195.945 109.961L200.154 109.961L200.154 105.793L195.945 105.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.945 97.4566L195.945 101.625L200.154 101.625L200.154 97.4566L195.945 97.4566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.945 89.1206L195.945 93.2891L200.154 93.2891L200.154 89.1206L195.945 89.1206Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.945 80.5816L195.945 84.75L200.154 84.75L200.154 80.5816L195.945 80.5816Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.414 105.793L205.414 109.961L209.623 109.961L209.623 105.793L205.414 105.793Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.414 97.4566L205.414 101.625L209.623 101.625L209.623 97.4566L205.414 97.4566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.414 89.1206L205.414 93.2891L209.623 93.2891L209.623 89.1206L205.414 89.1206Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.414 80.5816L205.414 84.75L209.623 84.75L209.623 80.5816L205.414 80.5816Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.879 97.4566L214.879 101.625L219.088 101.625L219.088 97.4566L214.879 97.4566Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.879 89.1206L214.879 93.2891L219.088 93.2891L219.088 89.1206L214.879 89.1206Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.879 80.5816L214.879 84.75L219.088 84.75L219.088 80.5816L214.879 80.5816Z",
    fill: "#FAFAFA"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip6_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2148 145.73L90.2148 151.422L95.927 151.422L95.927 145.73L90.2148 145.73Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2148 134.348L90.2148 140.039L95.927 140.039L95.927 134.348L90.2148 134.348Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2148 122.973L90.2148 128.664L95.927 128.664L95.927 122.973L90.2148 122.973Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.066 145.73L103.066 151.422L108.779 151.422L108.779 145.73L103.066 145.73Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.066 134.348L103.066 140.039L108.779 140.039L108.779 134.348L103.066 134.348Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.066 122.973L103.066 128.664L108.779 128.664L108.779 122.973L103.066 122.973Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.066 111.59L103.066 117.281L108.779 117.281L108.779 111.59L103.066 111.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.914 145.73L115.914 151.422L121.626 151.422L121.626 145.73L115.914 145.73Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.914 134.348L115.914 140.039L121.626 140.039L121.626 134.348L115.914 134.348Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.914 122.973L115.914 128.664L121.626 128.664L121.626 122.973L115.914 122.973Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.914 111.59L115.914 117.281L121.626 117.281L121.626 111.59L115.914 111.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.914 100.207L115.914 105.898L121.626 105.898L121.626 100.207L115.914 100.207Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.766 134.348L128.766 140.039L134.478 140.039L134.478 134.348L128.766 134.348Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.766 122.973L128.766 128.664L134.478 128.664L134.478 122.973L128.766 122.973Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.766 111.59L128.766 117.281L134.478 117.281L134.478 111.59L128.766 111.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.766 100.207L128.766 105.898L134.478 105.898L134.478 100.207L128.766 100.207Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.766 88.5507L128.766 94.2422L134.478 94.2422L134.478 88.5507L128.766 88.5507Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.617 122.973L141.617 128.664L147.329 128.664L147.329 122.973L141.617 122.973Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.617 111.59L141.617 117.281L147.329 117.281L147.329 111.59L141.617 111.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.617 100.207L141.617 105.898L147.329 105.898L147.329 100.207L141.617 100.207Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.617 88.5507L141.617 94.2422L147.329 94.2422L147.329 88.5507L141.617 88.5507Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.465 111.59L154.465 117.281L160.177 117.281L160.177 111.59L154.465 111.59Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.465 100.207L154.465 105.898L160.177 105.898L160.177 100.207L154.465 100.207Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.465 88.5507L154.465 94.2422L160.177 94.2422L160.177 88.5507L154.465 88.5507Z",
    fill: "#FAFAFA"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip7_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.707 938.043L918.707 942.211L922.916 942.211L922.916 938.043L918.707 938.043Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.707 929.707L918.707 933.875L922.916 933.875L922.916 929.707L918.707 929.707Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.707 921.371L918.707 925.539L922.916 925.539L922.916 921.371L918.707 921.371Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.176 938.043L928.176 942.211L932.385 942.211L932.385 938.043L928.176 938.043Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.176 929.707L928.176 933.875L932.385 933.875L932.385 929.707L928.176 929.707Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.176 921.371L928.176 925.539L932.385 925.539L932.385 921.371L928.176 921.371Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.176 913.035L928.176 917.203L932.385 917.203L932.385 913.035L928.176 913.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.645 938.043L937.645 942.211L941.853 942.211L941.853 938.043L937.645 938.043Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.645 929.707L937.645 933.875L941.853 933.875L941.853 929.707L937.645 929.707Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.645 921.371L937.645 925.539L941.853 925.539L941.853 921.371L937.645 921.371Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.645 913.035L937.645 917.203L941.853 917.203L941.853 913.035L937.645 913.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.645 904.699L937.645 908.867L941.853 908.867L941.853 904.699L937.645 904.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.113 929.707L947.113 933.875L951.322 933.875L951.322 929.707L947.113 929.707Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.113 921.371L947.113 925.539L951.322 925.539L951.322 921.371L947.113 921.371Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.113 913.035L947.113 917.203L951.322 917.203L951.322 913.035L947.113 913.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.113 904.699L947.113 908.867L951.322 908.867L951.322 904.699L947.113 904.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.113 896.16L947.113 900.328L951.322 900.328L951.322 896.16L947.113 896.16Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.582 921.371L956.582 925.539L960.791 925.539L960.791 921.371L956.582 921.371Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.582 913.035L956.582 917.203L960.791 917.203L960.791 913.035L956.582 913.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.582 904.699L956.582 908.867L960.791 908.867L960.791 904.699L956.582 904.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.582 896.16L956.582 900.328L960.791 900.328L960.791 896.16L956.582 896.16Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.047 913.035L966.047 917.203L970.256 917.203L970.256 913.035L966.047 913.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.047 904.699L966.047 908.867L970.256 908.867L970.256 904.699L966.047 904.699Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.047 896.16L966.047 900.328L970.256 900.328L970.256 896.16L966.047 896.16Z",
    fill: "#FAFAFA"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip8_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.375 961.308L841.375 967L847.087 967L847.087 961.308L841.375 961.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.375 949.926L841.375 955.617L847.087 955.617L847.087 949.926L841.375 949.926Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.375 938.551L841.375 944.242L847.087 944.242L847.087 938.551L841.375 938.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.227 961.308L854.227 967L859.939 967L859.939 961.308L854.227 961.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.227 949.926L854.227 955.617L859.939 955.617L859.939 949.926L854.227 949.926Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.227 938.551L854.227 944.242L859.939 944.242L859.939 938.551L854.227 938.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.227 927.168L854.227 932.859L859.939 932.859L859.939 927.168L854.227 927.168Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.074 961.308L867.074 967L872.786 967L872.786 961.308L867.074 961.308Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.074 949.926L867.074 955.617L872.786 955.617L872.786 949.926L867.074 949.926Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.074 938.551L867.074 944.242L872.786 944.242L872.786 938.551L867.074 938.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.074 927.168L867.074 932.859L872.786 932.859L872.786 927.168L867.074 927.168Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.074 915.785L867.074 921.477L872.786 921.477L872.786 915.785L867.074 915.785Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.926 949.926L879.926 955.617L885.638 955.617L885.638 949.926L879.926 949.926Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.926 938.551L879.926 944.242L885.638 944.242L885.638 938.551L879.926 938.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.926 927.168L879.926 932.859L885.638 932.859L885.638 927.168L879.926 927.168Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.926 915.785L879.926 921.477L885.638 921.477L885.638 915.785L879.926 915.785Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.926 904.129L879.926 909.82L885.638 909.82L885.638 904.129L879.926 904.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.777 938.551L892.777 944.242L898.489 944.242L898.489 938.551L892.777 938.551Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.777 927.168L892.777 932.859L898.489 932.859L898.489 927.168L892.777 927.168Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.777 915.785L892.777 921.477L898.489 921.477L898.489 915.785L892.777 915.785Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.777 904.129L892.777 909.82L898.489 909.82L898.489 904.129L892.777 904.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.625 927.168L905.625 932.859L911.337 932.859L911.337 927.168L905.625 927.168Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.625 915.785L905.625 921.477L911.337 921.477L911.337 915.785L905.625 915.785Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.625 904.129L905.625 909.82L911.337 909.82L911.337 904.129L905.625 904.129Z",
    fill: "#FAFAFA"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip9_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.258 550.805H674.758V554.131H678.258V550.805Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.258 550.805H681.758V554.131H685.258V550.805Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.254 550.805H688.754V554.131H692.254V550.805Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.258 558.289H674.758V561.615H678.258V558.289Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.258 558.289H681.758V561.615H685.258V558.289Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.254 558.289H688.754V561.615H692.254V558.289Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.254 558.289H695.754V561.615H699.254V558.289Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.258 565.766H674.758V569.091H678.258V565.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.258 565.766H681.758V569.091H685.258V565.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.254 565.766H688.754V569.091H692.254V565.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.254 565.766H695.754V569.091H699.254V565.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.254 565.766H702.754V569.091H706.254V565.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.258 573.25H681.758V576.576H685.258V573.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.254 573.25H688.754V576.576H692.254V573.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.254 573.25H695.754V576.576H699.254V573.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.254 573.25H702.754V576.576H706.254V573.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.422 573.25H709.922V576.576H713.422V573.25Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.254 580.734H688.754V584.06H692.254V580.734Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.254 580.734H695.754V584.06H699.254V580.734Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.254 580.734H702.754V584.06H706.254V580.734Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.422 580.734H709.922V584.06H713.422V580.734Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.254 588.211H695.754V591.537H699.254V588.211Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.254 588.211H702.754V591.537H706.254V588.211Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.422 588.211H709.922V591.537H713.422V588.211Z",
    fill: "#FAFAFA"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip10_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.172 508.305H258.672V511.631H262.172V508.305Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.172 508.305H265.672V511.631H269.172V508.305Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.168 508.305H272.668V511.631H276.168V508.305Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.172 515.789H258.672V519.115H262.172V515.789Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.172 515.789H265.672V519.115H269.172V515.789Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.168 515.789H272.668V519.115H276.168V515.789Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.168 515.789H279.668V519.115H283.168V515.789Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.172 523.266H258.672V526.591H262.172V523.266Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.172 523.266H265.672V526.591H269.172V523.266Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.168 523.266H272.668V526.591H276.168V523.266Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.168 523.266H279.668V526.591H283.168V523.266Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.168 523.266H286.668V526.591H290.168V523.266Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.172 530.75H265.672V534.076H269.172V530.75Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.168 530.75H272.668V534.076H276.168V530.75Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.168 530.75H279.668V534.076H283.168V530.75Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.168 530.75H286.668V534.076H290.168V530.75Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.336 530.75H293.836V534.076H297.336V530.75Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.168 538.234H272.668V541.56H276.168V538.234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.168 538.234H279.668V541.56H283.168V538.234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.168 538.234H286.668V541.56H290.168V538.234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.336 538.234H293.836V541.56H297.336V538.234Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.168 545.711H279.668V549.037H283.168V545.711Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.168 545.711H286.668V549.037H290.168V545.711Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.336 545.711H293.836V549.037H297.336V545.711Z",
    fill: "#FAFAFA"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip11_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.21 255.031H1079.8V260.165H1085.21V255.031Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.05 255.031H1090.63V260.165H1096.05V255.031Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.87 255.031H1101.46V260.165H1106.87V255.031Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.21 266.578H1079.8V271.712H1085.21V266.578Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.05 266.578H1090.63V271.712H1096.05V266.578Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.87 266.578H1101.46V271.712H1106.87V266.578Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.71 266.578H1112.29V271.712H1117.71V266.578Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.21 278.125H1079.8V283.258H1085.21V278.125Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.05 278.125H1090.63V283.258H1096.05V278.125Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.87 278.125H1101.46V283.258H1106.87V278.125Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.71 278.125H1112.29V283.258H1117.71V278.125Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.54 278.125H1123.12V283.258H1128.54V278.125Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.05 289.68H1090.63V294.813H1096.05V289.68Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.87 289.68H1101.46V294.813H1106.87V289.68Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.71 289.68H1112.29V294.813H1117.71V289.68Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.54 289.68H1123.12V294.813H1128.54V289.68Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.63 289.68H1134.21V294.813H1139.63V289.68Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.87 301.227H1101.46V306.36H1106.87V301.227Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.71 301.227H1112.29V306.36H1117.71V301.227Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.54 301.227H1123.12V306.36H1128.54V301.227Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.63 301.227H1134.21V306.36H1139.63V301.227Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.71 312.773H1112.29V317.907H1117.71V312.773Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.54 312.773H1123.12V317.907H1128.54V312.773Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.63 312.773H1134.21V317.907H1139.63V312.773Z",
    fill: "#FAFAFA"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip12_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663.604 0H658.188V5.13339H663.604V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.436 0H669.02V5.13339H674.436V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.264 0H679.848V5.13339H685.264V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.604 11.5469H658.188V16.6803H663.604V11.5469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.436 11.5469H669.02V16.6803H674.436V11.5469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.264 11.5469H679.848V16.6803H685.264V11.5469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.096 11.5469H690.68V16.6803H696.096V11.5469Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.604 23.0938H658.188V28.2271H663.604V23.0938Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.436 23.0938H669.02V28.2271H674.436V23.0938Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.264 23.0938H679.848V28.2271H685.264V23.0938Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.096 23.0938H690.68V28.2271H696.096V23.0938Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.932 23.0938H701.516V28.2271H706.932V23.0938Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.436 34.6484H669.02V39.7818H674.436V34.6484Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.264 34.6484H679.848V39.7818H685.264V34.6484Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.096 34.6484H690.68V39.7818H696.096V34.6484Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.932 34.6484H701.516V39.7818H706.932V34.6484Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.022 34.6484H712.605V39.7818H718.022V34.6484Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.264 46.1953H679.848V51.3287H685.264V46.1953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.096 46.1953H690.68V51.3287H696.096V46.1953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.932 46.1953H701.516V51.3287H706.932V46.1953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.022 46.1953H712.605V51.3287H718.022V46.1953Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.096 57.7422H690.68V62.8756H696.096V57.7422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.932 57.7422H701.516V62.8756H706.932V57.7422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.022 57.7422H712.605V62.8756H718.022V57.7422Z",
    fill: "#FAFAFA"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip13_20344_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1764.58 7.96875H1759.16V13.1021H1764.58V7.96875Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.41 7.96875H1770V13.1021H1775.41V7.96875Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.24 7.96875H1780.82V13.1021H1786.24V7.96875Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.58 19.5156H1759.16V24.649H1764.58V19.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.41 19.5156H1770V24.649H1775.41V19.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.24 19.5156H1780.82V24.649H1786.24V19.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.07 19.5156H1791.66V24.649H1797.07V19.5156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.58 31.0625H1759.16V36.1959H1764.58V31.0625Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.41 31.0625H1770V36.1959H1775.41V31.0625Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.24 31.0625H1780.82V36.1959H1786.24V31.0625Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.07 31.0625H1791.66V36.1959H1797.07V31.0625Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.91 31.0625H1802.49V36.1959H1807.91V31.0625Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.41 42.6172H1770V47.7506H1775.41V42.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.24 42.6172H1780.82V47.7506H1786.24V42.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.07 42.6172H1791.66V47.7506H1797.07V42.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.91 42.6172H1802.49V47.7506H1807.91V42.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819 42.6172H1813.58V47.7506H1819V42.6172Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.24 54.1641H1780.82V59.2975H1786.24V54.1641Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.07 54.1641H1791.66V59.2975H1797.07V54.1641Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.91 54.1641H1802.49V59.2975H1807.91V54.1641Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819 54.1641H1813.58V59.2975H1819V54.1641Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.07 65.7109H1791.66V70.8443H1797.07V65.7109Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.91 65.7109H1802.49V70.8443H1807.91V65.7109Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819 65.7109H1813.58V70.8443H1819V65.7109Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 303.78,
    height: 292.227,
    fill: "white",
    transform: "translate(2.76172 705.766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.714,
    height: 143.058,
    fill: "white",
    transform: "translate(1534.55 123.094)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.877,
    height: 123.975,
    fill: "white",
    transform: "translate(344.285 663.266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.0479,
    height: 51.5506,
    fill: "white",
    transform: "translate(568.895 363.07) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.8731,
    height: 69.9615,
    fill: "white",
    transform: "translate(491.57 387.867) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.0479,
    height: 51.5506,
    fill: "white",
    transform: "translate(167.539 126.633) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.8731,
    height: 69.9615,
    fill: "white",
    transform: "translate(90.2148 151.422) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.0479,
    height: 51.5506,
    fill: "white",
    transform: "translate(918.707 942.211) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.8731,
    height: 69.9615,
    fill: "white",
    transform: "translate(841.375 967) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.663,
    height: 40.7347,
    fill: "white",
    transform: "translate(674.758 550.805)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.663,
    height: 40.7347,
    fill: "white",
    transform: "translate(258.672 508.305)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8355,
    height: 62.8731,
    fill: "white",
    transform: "translate(1079.8 255.031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8355,
    height: 62.8731,
    fill: "white",
    transform: "translate(658.188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_20344_92055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8355,
    height: 62.8731,
    fill: "white",
    transform: "translate(1759.16 7.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgImg);
export default __webpack_public_path__ + "static/media/LoginBgImg.2d296b16143c661708c5e6ea4f80db29.svg";
export { ForwardRef as ReactComponent };